import { Heading } from '@chakra-ui/react'
import React from 'react'

export default function PageHeader({headerTitle}) {
  return (
    <Heading
        size="xl"
        bgGradient="linear(to-r, orange.400, orange.600)"
        bgClip="text"
        fontWeight="extrabold"
    >
        {headerTitle}
    </Heading>
  )
}
